// src/services/shopService.js

export const buySkin = (userProgress, item) => {
  const xp = userProgress.xp || 0;

  if (xp < item.cost) {
    return { ok: false, reason: 'not_enough_xp' };
  }

  // ✅ CAMBIO: Usa unlockedSkins en lugar de unlockedSkins
  const unlockedSkins = userProgress.unlockedSkins || [];

  const newData = {
    ...userProgress,
    xp: xp - item.cost,
    unlockedSkins: [...new Set([...unlockedSkins, item.id])], // ✅ Cambiado
    currentSkin: item.id // Auto-equipa la skin comprada
  };

  return { ok: true, newData };
};

export const equipSkin = (userProgress, skinId) => {
  return { ok: true, newData: { ...userProgress, currentSkin: skinId } };
};

export const buyContent = (userProgress, itemId, cost) => {
  const xp = userProgress.xp || 0;

  if (xp < cost) {
    return { ok: false, reason: 'not_enough_xp' };
  }

  const unlockedContent = userProgress.unlockedContent || [];

  const newData = {
    ...userProgress,
    xp: xp - cost,
    unlockedContent: [...new Set([...unlockedContent, itemId])]
  };

  return { ok: true, newData };
};

/**
 * Lógica unificada del Cofre con Probabilidades Jerárquicas:
 * Vocab Normal (50%) > Vocab Misterioso (25%) > Skins (15%) > Jackpot (10%)
 */
export const buySurpriseChest = ({ userProgress, cost, skinsData, vocabularyData }) => {
  const xp = userProgress.xp || 0;
  if (xp < cost) return { ok: false, reason: 'not_enough_xp' };

  // ✅ CAMBIO: Usa unlockedSkins en lugar de unlockedSkins
  const unlockedSkins = userProgress.unlockedSkins || [];
  const unlockedContent = userProgress.unlockedContent || [];

  // 1. Clasificar todos los posibles premios
const poolNormalVocab = (vocabularyData?.sets || [])
  .filter(v => !v.isMystery && !unlockedContent.includes(v.id))
  .map(v => ({ 
    ...v, 
    category: 'vocab', 
    name: v.title,
    // ✅ Aseguramos que el motor reciba 'questions' sin importar el origen
    questions: v.questions || v.exercises 
  }));

const poolMysteryVocab = (vocabularyData?.sets || [])
  .filter(v => v.isMystery && !unlockedContent.includes(v.id))
  .map(v => ({ 
    ...v, 
    category: 'vocab', 
    name: v.title,
    questions: v.questions || v.exercises 
  }));

const poolSkins = (skinsData || [])
  .filter(s => s.isSecret && !unlockedSkins.includes(s.id))
  .map(s => ({ ...s, category: 'skin' }));
  // 2. Tirar el dado (0.00 a 1.00)
  const roll = Math.random();
  let wonItem = null;

  // --- LÓGICA DE PROBABILIDAD (De menor a mayor rareza) ---

  if (roll < 0.10) { 
    // 🎰 JACKPOT (10%)
    wonItem = { 
      id: 'jackpot_xp', 
      name: "¡JACKPOT DE XP!", 
      category: 'vocab', 
      emoji: "💰", 
      greeting: "¡Increíble! Has ganado 1000 XP adicionales." 
    };
    return { ok: true, wonItem, newData: { ...userProgress, xp: xp - cost + 1000 } };
  } 
  
  if (roll < 0.25 && poolSkins.length > 0) { 
    // 👕 SKINS (15%) -> Rango 0.10 a 0.25
    wonItem = poolSkins[Math.floor(Math.random() * poolSkins.length)];
  } 
  
  else if (roll < 0.50 && poolMysteryVocab.length > 0) { 
    // 🔮 VOCAB MISTERIOSO (25%) -> Rango 0.25 a 0.50
    wonItem = poolMysteryVocab[Math.floor(Math.random() * poolMysteryVocab.length)];
  } 
  
  else if (poolNormalVocab.length > 0) {
    // 📚 VOCAB NORMAL (50%) -> Rango 0.50 a 1.00
    wonItem = poolNormalVocab[Math.floor(Math.random() * poolNormalVocab.length)];
  }

  // --- SISTEMA DE FALLBACK (Si un pool está vacío, busca en los otros) ---
  if (!wonItem) {
    const backupPool = [...poolNormalVocab, ...poolMysteryVocab, ...poolSkins];
    if (backupPool.length === 0) return { ok: false, reason: 'all_unlocked' };
    wonItem = backupPool[Math.floor(Math.random() * backupPool.length)];
  }

  // 3. Aplicar cambios según el ítem ganado
  let newData = { ...userProgress, xp: xp - cost };

  if (wonItem.category === 'skin') {
    // ✅ CAMBIO: Usa unlockedSkins en lugar de unlockedSkins
    newData.unlockedSkins = [...new Set([...unlockedSkins, wonItem.id])];
  } else {
    newData.unlockedContent = [...new Set([...unlockedContent, wonItem.id])];
  }

  return { ok: true, newData, wonItem };
};
